import {TRUST_ACCOUNT_TABLE_MIN_WIDTH} from '@/features/trust-accounts/config';

import type {TrustAccountMenuAction} from '@/features/trust-accounts/components';

/** Keyed by column id; shared by every firm's table and its skeleton so columns line up across cards. */
export const GUEST_ACCOUNT_COLUMN_WIDTHS = {
  trustName: '28%',
  balance: '19%',
  type: '15%',
  invitedBy: '17%',
  sharedAt: '21%'
} as const;

export const GUEST_ACCOUNT_TABLE_PROPS = {
  variant: 'embedded',
  minWidth: TRUST_ACCOUNT_TABLE_MIN_WIDTH,
  rowLink: true
} as const;

/** A guest's ⋮ menu has only the copy-number item, which `TrustAccountMoreMenu` adds for a `refId`. */
export const GUEST_ACCOUNT_MENU_ACTIONS: TrustAccountMenuAction[] = [];

export const GUEST_FIRM_CARD_CLASS =
  'overflow-hidden rounded-2xl border border-border bg-background-surface';

export const GUEST_FIRM_PANEL_CLASS = 'border-t border-border';

export const GUEST_ACCOUNT_CARDS_CLASS = 'flex flex-col gap-7 p-5';
